import { fork } from 'redux-saga/effects';
import searchForm from './searchForm/sideEffects';
import lookups from './lookups/sideEffects';

export function* rootSaga() {
  yield fork(lookups);
  yield fork(searchForm);
}
